import { render, staticRenderFns } from "./Landwell.vue?vue&type=template&id=94dd89d4&scoped=true&"
import script from "./Landwell.vue?vue&type=script&lang=js&"
export * from "./Landwell.vue?vue&type=script&lang=js&"
import style0 from "./Landwell.vue?vue&type=style&index=0&id=94dd89d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd89d4",
  null
  
)

export default component.exports